module.exports = __webpack_public_path__ + "img/r-36.3118340c.jpg";